import { getBasicByIdWithoutHighlight } from '../../../lib/api';
import { map as rxMap, take } from 'rxjs/operators';
export default {
    components: {
        DeepViewDrawer: () => import('library-@/components/deep-view/drawer.vue'),
    },
    data() {
        return {
            DeepView_Lab_Mixin_currentDeepViewData: undefined,
            DeepView_Lab_Mixin_contextPatentIds: [],
        };
    },
    watch: {
        '$route': {
            handler: function() {
                this.DeepView_Lab_Mixin_currentDeepViewData = undefined;
                this.DeepView_Lab_Mixin_contextPatentIds = [];
            },
            immediate: true,
        },
    },
    computed: {
        DeepView_Lab_Mixin_isDeepViewLabOn() {
            // return _.get(window, 'zPREFACE.usedAnchorInLab.PATENT_DEEP_VIEW.enabled', false);
            return true;
        },
    },
    mounted() {
        this.$eventHub.$on('PATENT_VIEW:DeepView_Lab_Mixin_toggleDeepViewIcon', (rowData) => {
            this.DeepView_Lab_Mixin_toggleDeepViewIcon(rowData);
        });
    },
    beforeDestroy() {
        this.$eventHub.$off('PATENT_VIEW:DeepView_Lab_Mixin_toggleDeepViewIcon');
    },
    methods: {
        DeepView_Lab_Mixin_toggleDeepViewIcon(rowData) {
            if (
                this.DeepView_Lab_Mixin_currentDeepViewData && this.DeepView_Lab_Mixin_currentDeepViewData.PATENT_ID === rowData.PATENT_ID
            ) {
                this.DeepView_Lab_Mixin_currentDeepViewData = undefined;
                this.DeepView_Lab_Mixin_contextPatentIds = [];
            } else {
                this.DeepView_Lab_Mixin_currentDeepViewData = rowData;
                if (rowData.patentIds) {
                    this.DeepView_Lab_Mixin_contextPatentIds = rowData.patentIds;
                }
            }
        },
        DeepView_Lab_Mixin_switchPatent(patentId) {
            getBasicByIdWithoutHighlight(patentId).pipe(
                rxMap(resp => resp.data || {}),
                take(1),
            ).subscribe((patentInfo) => {
                const t = patentInfo.TITLE;
                const title = patentInfo.Origin_TITLE ||
                    (t && typeof t === 'object' ? (t[patentInfo.LANG_DEFAULT] || Object.values(t)[0] || '') : (t || ''));
                this.DeepView_Lab_Mixin_currentDeepViewData = {
                    PATENT_ID: patentId,
                    PN: patentInfo.PN || patentId,
                    TITLE: title,
                };
            });
        },
    },
};
